import { settings } from "../settings";

export const getStripeKey = () => {
    if (process.env.REACT_APP_LH_ENV === "production") {
        return settings.stripe.prodKey;
    } else return settings.stripe.devKey;
};
